<h2 mat-dialog-title>Select {{ enumMediaType[dialogData.type] | titlecase }}</h2>

<div class="dialog-container">
  <button class="btn" (click)="fileInput.click()">Select Files</button>
  <input #fileInput type="file" style="display:none" [attr.accept]="dialogData.type === enumMediaType.image ? 'image/*' : dialogData.type === enumMediaType.video ? 'video/*' : '*'" (change)="onFilesSelected($event)" multiple />

  <div class="preview-container" *ngIf="uploadQueue.length > 0">
    <div class="preview-item" *ngFor="let item of uploadQueue">
      <img class="preview-thumbnail" *ngIf="item.previewUrl && dialogData.type === enumMediaType.image" [src]="item.previewUrl" />
      <video class="preview-thumbnail" *ngIf="item.previewUrl && dialogData.type === enumMediaType.video" [src]="item.previewUrl" controls></video>
      <div class="preview-thumbnail" *ngIf="dialogData.type === enumMediaType.document"><span class="material-symbols-outlined">insert_drive_file</span></div>

      <div class="preview-name">{{ item.file.name }}</div>

      <mat-progress-bar class="upload-progress" *ngIf="!item.uploadResult?.path" [mode]="item.progress === -1 ? 'indeterminate' : 'determinate'" [value]="item.progress"></mat-progress-bar>
      <span *ngIf="item.uploadResult?.path" class="text-success">✔ Uploaded</span>

      <button class="btn btn-warning" (click)="cancelUpload(item)"><span class="material-symbols-outlined">close</span></button>
    </div>
  </div>

  <div class="caption-container">
    <p class="text-caption">Caption</p>
    <div class="caption-box">
      <input #inputText type="text" class="text-input" name="message" placeholder="Type your message..." />
    </div>
  </div>
</div>

<div class="dialog-actions">
  <button class="btn btn-secondary" (click)="onCancel()">Cancel</button>
  <button class="btn" (click)="onSend(inputText.value)" [disabled]="uploadedFiles.length === 0">Send</button>
</div>
